import React from 'react'
import Picker from '../common/Picker'
import ProductLabel from '../product/ProductLabel'

const OrderDetailPicker = (props) => {

    const option = (value) => <span className='flex items-center gap-x-2'><ProductLabel state={value.product} /><span className='bg-green-700 px-2 py-1 text-white text-xs rounded-full'>{value.unitPrice} {props.currency}/m </span>  </span>

    return (
        <Picker
            {...props}
            option={option}
        />
    )
}

export default OrderDetailPicker